import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import classnames from 'classnames';
import { Icon } from '@bwoty-web/ui-kit';
import { UI_CHECKMARK } from '@bwoty-web/ui-kit/icons';

import './uspList.scss';

const UspList = ({ aboutLabel = null, iconPath = null, usps = [] }) => {
  if (usps.length < 1) {
    return null;
  }
  return (
    <div className="gw-usps_container">
      {aboutLabel && <p className="gw-usps_heading">{aboutLabel}</p>}
      <div className="gw-usps">
        <ul className="gw-usp-list">
          {usps.map((usp) => {
            const uspClasses = classnames('gw-usp-list__item', {
              'gw-usp-list__item--standard': !iconPath,
            });
            return (
              <li className={uspClasses} key={uniqid('usp-list-item-')}>
                {iconPath && (
                  <Icon
                    alt=""
                    className="gw-usp-list-item__icon"
                    path={UI_CHECKMARK}
                    size="xs"
                  />
                )}
                {usp}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

UspList.propTypes = {
  aboutLabel: PropTypes.string,
  iconPath: PropTypes.shape({}),
  usps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default UspList;
